var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.notSummaryRecord
    ? _c(
        "div",
        { staticClass: "c-table-actions" },
        [
          _vm.displayEmployeeForm
            ? _c("employee-form", { ref: "createEmployee" })
            : _vm._e(),
          _c("m-confirmation", {
            attrs: {
              id: "delete-employee",
              active: _vm.isActiveDeleteConfirmationModal,
              "modal-title": "Удаление сотрудника",
              "modal-text": `Сотрудник <span>${_vm.record.fullName.value}</span> будет удалён без возможности восстановления`,
              buttons: [
                { label: "Отменить", size: "large", action: "closeModal" },
                {
                  label: "Удалить",
                  size: "large",
                  color: "pink",
                  action: "deleteEmployee",
                },
              ],
            },
            on: {
              deleteEmployee: _vm.deleteEmployee,
              close: function ($event) {
                _vm.isActiveDeleteConfirmationModal = false
              },
            },
          }),
          _c("m-confirmation", {
            attrs: {
              id: "delete-employee",
              active: _vm.isActiveDeleteCalcConfirmationModal,
              "modal-title": "Удаление расчета",
              "modal-text": `Расчет будет удалён без возможности восстановления`,
              buttons: [
                { label: "Отменить", size: "large", action: "closeModal" },
                {
                  label: "Удалить",
                  size: "large",
                  color: "pink",
                  action: "deleteCalc",
                },
              ],
            },
            on: {
              deleteCalc: _vm.deleteCalc,
              close: function ($event) {
                _vm.isActiveDeleteCalcConfirmationModal = false
              },
            },
          }),
          _c("m-change-status", {
            attrs: {
              id: "change-employee-status",
              active: _vm.isActiveChangeEmployeeStatusModal,
              record: _vm.record,
              "modal-title": "Изменить статус сотрудника",
            },
            on: {
              close: function ($event) {
                _vm.isActiveChangeEmployeeStatusModal = false
              },
            },
          }),
          _c("m-create-user-for-employee", {
            attrs: {
              id: "create-user-for-employee",
              active: _vm.isActiveCreateUserForEmployeeModal,
              record: _vm.record,
              "modal-title": "Создать пользователя для сотрудника",
            },
            on: {
              close: function ($event) {
                _vm.isActiveCreateUserForEmployeeModal = false
              },
            },
          }),
          _c("div", {
            staticClass: "c-table-actions__overlay",
            class: { "c-table-actions__overlay_hidden": !_vm.menuActive },
            on: {
              click: function ($event) {
                _vm.menuActive = false
              },
            },
          }),
          _vm.type === "employees"
            ? _c(
                "div",
                { staticClass: "c-table-actions__wrapper" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "c-table-actions__action",
                      on: {
                        click: function ($event) {
                          return _vm.goToWorksheet(_vm.record.id)
                        },
                      },
                    },
                    [
                      _vm.getWorksheetStatus() === "warning"
                        ? _c(
                            "div",
                            {
                              staticClass: "c-table-actions__icon",
                              attrs: {
                                id: `c-table-actions__action-worksheet-warning-${_vm.recordIndex}`,
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "15",
                                    height: "17",
                                    viewBox: "0 0 15 17",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M1 4V3H0V4H1ZM1 16H0V17H1V16ZM11 16V17H12V16H11ZM11 4H12V3H11V4ZM5 10C5 10.5523 5.44772 11 6 11C6.55228 11 7 10.5523 7 10H5ZM7 7C7 6.44772 6.55228 6 6 6C5.44772 6 5 6.44772 5 7H7ZM0 4V16H2V4H0ZM1 17H11V15H1V17ZM10 4V16H12V4H10ZM1 5H11V3H1V5ZM7 10V7H5V10H7Z",
                                      fill: "#FFB800",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M4 4.5V1H14V13H11",
                                      stroke: "#FFB800",
                                      "stroke-width": "2",
                                    },
                                  }),
                                  _c("circle", {
                                    attrs: {
                                      cx: "6",
                                      cy: "13",
                                      r: "1",
                                      fill: "#FFB800",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.getWorksheetStatus() === "success"
                        ? _c(
                            "div",
                            {
                              staticClass: "c-table-actions__icon",
                              attrs: {
                                id: `c-table-actions__action-worksheet-success-${_vm.recordIndex}`,
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "15",
                                    height: "17",
                                    viewBox: "0 0 15 17",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M1 4V3H0V4H1ZM1 16H0V17H1V16ZM11 16V17H12V16H11ZM11 4H12V3H11V4ZM4.70711 9.29289C4.31658 8.90237 3.68342 8.90237 3.29289 9.29289C2.90237 9.68342 2.90237 10.3166 3.29289 10.7071L4.70711 9.29289ZM5 11L4.29289 11.7071C4.68342 12.0976 5.31658 12.0976 5.70711 11.7071L5 11ZM8.70711 8.70711C9.09763 8.31658 9.09763 7.68342 8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289L8.70711 8.70711ZM14 1H15V0H14V1ZM14 13V14H15V13H14ZM4 1V0H3V1H4ZM0 4V16H2V4H0ZM1 17H11V15H1V17ZM10 4V16H12V4H10ZM1 5H11V3H1V5ZM3.29289 10.7071L4.29289 11.7071L5.70711 10.2929L4.70711 9.29289L3.29289 10.7071ZM5.70711 11.7071L8.70711 8.70711L7.29289 7.29289L4.29289 10.2929L5.70711 11.7071ZM13 1V13H15V1H13ZM4 2H14V0H4V2ZM3 1V4.5H5V1H3ZM11 14H14V12H11V14Z",
                                      fill: "#12C971",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.getWorksheetStatus() === "error"
                        ? _c(
                            "div",
                            {
                              staticClass: "c-table-actions__icon",
                              attrs: {
                                id: `c-table-actions__action-worksheet-error-${_vm.recordIndex}`,
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "15",
                                    height: "17",
                                    viewBox: "0 0 15 17",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M1 4V3H0V4H1ZM1 16H0V17H1V16ZM11 16V17H12V16H11ZM11 4H12V3H11V4ZM4.70711 7.29289C4.31658 6.90237 3.68342 6.90237 3.29289 7.29289C2.90237 7.68342 2.90237 8.31658 3.29289 8.70711L4.70711 7.29289ZM7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071C9.09763 12.3166 9.09763 11.6834 8.70711 11.2929L7.29289 12.7071ZM8.70711 8.70711C9.09763 8.31658 9.09763 7.68342 8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289L8.70711 8.70711ZM3.29289 11.2929C2.90237 11.6834 2.90237 12.3166 3.29289 12.7071C3.68342 13.0976 4.31658 13.0976 4.70711 12.7071L3.29289 11.2929ZM14 1H15V0H14V1ZM14 13V14H15V13H14ZM4 1V0H3V1H4ZM0 4V16H2V4H0ZM1 17H11V15H1V17ZM10 4V16H12V4H10ZM1 5H11V3H1V5ZM3.29289 8.70711L5.29289 10.7071L6.70711 9.29289L4.70711 7.29289L3.29289 8.70711ZM5.29289 10.7071L7.29289 12.7071L8.70711 11.2929L6.70711 9.29289L5.29289 10.7071ZM7.29289 7.29289L5.29289 9.29289L6.70711 10.7071L8.70711 8.70711L7.29289 7.29289ZM5.29289 9.29289L3.29289 11.2929L4.70711 12.7071L6.70711 10.7071L5.29289 9.29289ZM13 1V13H15V1H13ZM4 2H14V0H4V2ZM3 1V4.5H5V1H3ZM11 14H14V12H11V14Z",
                                      fill: "#FF238D",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "c-table-actions__action",
                      attrs: {
                        id: `c-table-actions__action-menu-${_vm.recordIndex}`,
                        tabindex: "-1",
                      },
                    },
                    [
                      _c("div", { staticClass: "c-table-actions__icon" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "12",
                              height: "10",
                              viewBox: "0 0 12 10",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M1 1H11M1 5H11M1 9H11",
                                stroke: "#8E9CBB",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm.shouldDisplayEditWorkerOption
                    ? _c(
                        "b-popover",
                        {
                          attrs: {
                            id: `c-table-actions-menu-popover-${_vm.recordIndex}`,
                            placement: "bottomleft",
                            triggers: "click",
                            target: `c-table-actions__action-menu-${_vm.recordIndex}`,
                          },
                          on: { show: _vm.onShowActionsMenuPopover },
                        },
                        [
                          _c("div", { staticClass: "c-table-actions__menu" }, [
                            _c(
                              "div",
                              { staticClass: "c-table-actions__menu-item" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-table-actions__menu-item-icon",
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "14",
                                          height: "14",
                                          viewBox: "0 0 14 14",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M9.33943 1.62805L8.63232 0.920947L8.63232 0.920948L9.33943 1.62805ZM10.8557 1V0V1ZM13 3.14431H14H13ZM12.3719 4.66057L11.6648 3.95346L11.6648 3.95346L12.3719 4.66057ZM5.16971 11.8628L5.43283 12.8276C5.60073 12.7818 5.75376 12.693 5.87682 12.5699L5.16971 11.8628ZM1 13L0.0352364 12.7369C-0.0591854 13.0831 0.0391427 13.4534 0.292893 13.7071C0.546642 13.9609 0.916904 14.0592 1.26312 13.9648L1 13ZM2.13719 8.8303L1.43009 8.12319C1.30703 8.24625 1.21822 8.39929 1.17243 8.56718L2.13719 8.8303ZM10.0465 2.33516C10.1528 2.2289 10.2789 2.14461 10.4178 2.08711L9.65241 0.239346C9.27093 0.397362 8.9243 0.62897 8.63232 0.920947L10.0465 2.33516ZM10.4178 2.08711C10.5566 2.0296 10.7054 2 10.8557 2V0C10.4428 0 10.0339 0.0813298 9.65241 0.239346L10.4178 2.08711ZM10.8557 2C11.006 2 11.1548 2.0296 11.2936 2.08711L12.059 0.239346C11.6775 0.0813296 11.2686 0 10.8557 0V2ZM11.2936 2.08711C11.4324 2.14461 11.5586 2.2289 11.6648 2.33516L13.0791 0.920947C12.7871 0.628971 12.4404 0.397363 12.059 0.239346L11.2936 2.08711ZM11.6648 2.33516C11.7711 2.44142 11.8554 2.56757 11.9129 2.7064L13.7607 1.94103C13.6026 1.55955 13.371 1.21292 13.0791 0.920947L11.6648 2.33516ZM11.9129 2.7064C11.9704 2.84523 12 2.99403 12 3.14431H14C14 2.7314 13.9187 2.32252 13.7607 1.94103L11.9129 2.7064ZM12 3.14431C12 3.29459 11.9704 3.44339 11.9129 3.58222L13.7607 4.34759C13.9187 3.9661 14 3.55722 14 3.14431H12ZM11.9129 3.58222C11.8554 3.72105 11.7711 3.8472 11.6648 3.95346L13.0791 5.36768C13.371 5.0757 13.6026 4.72907 13.7607 4.34759L11.9129 3.58222ZM11.6648 3.95346L4.46261 11.1557L5.87682 12.5699L13.0791 5.36767L11.6648 3.95346ZM4.9066 10.898L0.736884 12.0352L1.26312 13.9648L5.43283 12.8276L4.9066 10.898ZM1.96476 13.2631L3.10196 9.09342L1.17243 8.56718L0.0352364 12.7369L1.96476 13.2631ZM2.8443 9.53741L10.0465 2.33516L8.63232 0.920948L1.43009 8.12319L2.8443 9.53741ZM7 4L10 7L11.4142 5.58579L8.41421 2.58579L7 4Z",
                                            fill: "#8E9CBB",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-table-actions__menu-item-label",
                                    on: {
                                      click: function ($event) {
                                        return _vm.editWorker(_vm.record.id)
                                      },
                                    },
                                  },
                                  [_vm._v("Редактировать")]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "c-table-actions__menu-item" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-table-actions__menu-item-icon",
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "14",
                                          height: "14",
                                          viewBox: "0 0 14 14",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M0 11.9998C0 12.552 0.447715 12.9998 1 12.9998C1.55228 12.9998 2 12.552 2 11.9998H0ZM1 8.99976V7.99976C0.447715 7.99976 0 8.44747 0 8.99976H1ZM4 9.99976C4.55228 9.99976 5 9.55204 5 8.99976C5 8.44747 4.55228 7.99976 4 7.99976V9.99976ZM14 2C14 1.44772 13.5523 1 13 1C12.4477 1 12 1.44772 12 2H14ZM13 5V6C13.5523 6 14 5.55229 14 5H13ZM10 4C9.44771 4 9 4.44772 9 5C9 5.55229 9.44771 6 10 6V4ZM13.9256 9.37287C14.1079 8.85153 13.833 8.28115 13.3116 8.09889C12.7903 7.91663 12.2199 8.19151 12.0376 8.71286L13.9256 9.37287ZM2.98648 9.22376C2.74671 8.72624 2.14902 8.51729 1.6515 8.75706C1.15397 8.99683 0.945023 9.59452 1.18479 10.092L2.98648 9.22376ZM0.574402 4.81463C0.392144 5.33598 0.667027 5.90636 1.18837 6.08862C1.70972 6.27088 2.2801 5.99599 2.46236 5.47465L0.574402 4.81463ZM11.5135 4.96374C11.7533 5.46127 12.351 5.67022 12.8485 5.43045C13.346 5.19068 13.555 4.59298 13.3152 4.09546L11.5135 4.96374ZM2 11.9998V8.99976H0V11.9998H2ZM1 9.99976H4V7.99976H1V9.99976ZM12 2V5H14V2H12ZM13 4H10V6H13V4ZM12.0376 8.71286C11.7174 9.62886 11.1327 10.4293 10.3576 11.0131L11.5607 12.6107C12.6518 11.7891 13.4748 10.6623 13.9256 9.37287L12.0376 8.71286ZM10.3576 11.0131C9.58242 11.5968 8.65157 11.9375 7.68275 11.9922L7.79546 13.989C9.15922 13.912 10.4695 13.4324 11.5607 12.6107L10.3576 11.0131ZM7.68275 11.9922C6.71393 12.0469 5.75065 11.8131 4.91472 11.3203L3.89906 13.0432C5.07575 13.7369 6.43171 14.066 7.79546 13.989L7.68275 11.9922ZM4.91472 11.3203C4.07879 10.8275 3.40776 10.0979 2.98648 9.22376L1.18479 10.092C1.7778 11.3225 2.72237 12.3495 3.89906 13.0432L4.91472 11.3203ZM2.46236 5.47465C2.78259 4.55865 3.36725 3.75817 4.14241 3.17445L2.93932 1.57678C1.84817 2.39844 1.02517 3.52523 0.574402 4.81463L2.46236 5.47465ZM4.14241 3.17445C4.91758 2.59073 5.84843 2.24999 6.81725 2.1953L6.70454 0.198478C5.34078 0.275458 4.03048 0.755108 2.93932 1.57678L4.14241 3.17445ZM6.81725 2.1953C7.78607 2.14061 8.74935 2.37444 9.58528 2.86722L10.6009 1.14431C9.42425 0.45065 8.06829 0.121499 6.70454 0.198478L6.81725 2.1953ZM9.58528 2.86722C10.4212 3.36 11.0922 4.0896 11.5135 4.96374L13.3152 4.09546C12.7222 2.86497 11.7776 1.83796 10.6009 1.14431L9.58528 2.86722Z",
                                            fill: "#8E9CBB",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-table-actions__menu-item-label",
                                    on: {
                                      click: function ($event) {
                                        _vm.isActiveChangeEmployeeStatusModal = true
                                      },
                                    },
                                  },
                                  [_vm._v(" Изменить статус ")]
                                ),
                              ]
                            ),
                            _vm.infoAboutUserEmployee &&
                            !_vm.infoAboutUserEmployee.user_exist
                              ? _c(
                                  "div",
                                  { staticClass: "c-table-actions__menu-item" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-table-actions__menu-item-icon",
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "20",
                                              height: "18",
                                              viewBox: "0 0 18 18",
                                              fill: "none",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M10.5 11.9863C11.0523 11.9863 11.5 11.5386 11.5 10.9863C11.5 10.434 11.0523 9.98628 10.5 9.98628V11.9863ZM5.23896 10.9863V9.98628V10.9863ZM1.5 14.9745H0.5H1.5ZM0.5 16.0625C0.5 16.6148 0.947715 17.0625 1.5 17.0625C2.05228 17.0625 2.5 16.6148 2.5 16.0625H0.5ZM12.5 13C11.9477 13 11.5 13.4477 11.5 14C11.5 14.5523 11.9477 15 12.5 15V13ZM16.5 15C17.0523 15 17.5 14.5523 17.5 14C17.5 13.4477 17.0523 13 16.5 13V15ZM13.5 16C13.5 16.5523 13.9477 17 14.5 17C15.0523 17 15.5 16.5523 15.5 16H13.5ZM15.5 12C15.5 11.4477 15.0523 11 14.5 11C13.9477 11 13.5 11.4477 13.5 12H15.5ZM10.5 9.98628H5.23896V11.9863H10.5V9.98628ZM5.23896 9.98628C3.96052 9.98628 2.74859 10.5286 1.86558 11.4705L3.32465 12.8383C3.84403 12.2843 4.53413 11.9863 5.23896 11.9863V9.98628ZM1.86558 11.4705C0.984619 12.4102 0.5 13.6716 0.5 14.9745H2.5C2.5 14.1619 2.80323 13.3945 3.32465 12.8383L1.86558 11.4705ZM0.5 14.9745V16.0625H2.5V14.9745H0.5ZM10.455 3.99117C10.455 5.09086 9.56355 5.98234 8.46386 5.98234V7.98234C10.6681 7.98234 12.455 6.19543 12.455 3.99117H10.455ZM8.46386 5.98234C7.36417 5.98234 6.47269 5.09086 6.47269 3.99117H4.47269C4.47269 6.19543 6.2596 7.98234 8.46386 7.98234V5.98234ZM6.47269 3.99117C6.47269 2.89148 7.36417 2 8.46386 2V0C6.2596 0 4.47269 1.78691 4.47269 3.99117H6.47269ZM8.46386 2C9.56355 2 10.455 2.89148 10.455 3.99117H12.455C12.455 1.78691 10.6681 0 8.46386 0V2ZM12.5 15H14.5V13H12.5V15ZM14.5 15H16.5V13H14.5V15ZM15.5 16V14H13.5V16H15.5ZM15.5 14V12H13.5V14H15.5Z",
                                                fill: "#8E9CBB",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-table-actions__menu-item-label",
                                        on: {
                                          click: function ($event) {
                                            _vm.isActiveCreateUserForEmployeeModal = true
                                          },
                                        },
                                      },
                                      [_vm._v(" Создать пользователя ")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.infoAboutUserEmployee &&
                            _vm.infoAboutUserEmployee.user_exist &&
                            _vm.infoAboutUserEmployee.user_status === 1
                              ? _c(
                                  "div",
                                  { staticClass: "c-table-actions__menu-item" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-table-actions__menu-item-icon",
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "20",
                                              height: "18",
                                              viewBox: "0 0 18 18",
                                              fill: "none",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M10.5 11.9863C11.0523 11.9863 11.5 11.5386 11.5 10.9863C11.5 10.434 11.0523 9.98628 10.5 9.98628V11.9863ZM5.23896 10.9863V9.98628V10.9863ZM1.5 14.9745H0.5H1.5ZM0.5 16.0625C0.5 16.6148 0.947715 17.0625 1.5 17.0625C2.05228 17.0625 2.5 16.6148 2.5 16.0625H0.5ZM12.5 13C11.9477 13 11.5 13.4477 11.5 14C11.5 14.5523 11.9477 15 12.5 15V13ZM16.5 15C17.0523 15 17.5 14.5523 17.5 14C17.5 13.4477 17.0523 13 16.5 13V15ZM13.5 16C13.5 16.5523 13.9477 17 14.5 17C15.0523 17 15.5 16.5523 15.5 16H13.5ZM15.5 12C15.5 11.4477 15.0523 11 14.5 11C13.9477 11 13.5 11.4477 13.5 12H15.5ZM10.5 9.98628H5.23896V11.9863H10.5V9.98628ZM5.23896 9.98628C3.96052 9.98628 2.74859 10.5286 1.86558 11.4705L3.32465 12.8383C3.84403 12.2843 4.53413 11.9863 5.23896 11.9863V9.98628ZM1.86558 11.4705C0.984619 12.4102 0.5 13.6716 0.5 14.9745H2.5C2.5 14.1619 2.80323 13.3945 3.32465 12.8383L1.86558 11.4705ZM0.5 14.9745V16.0625H2.5V14.9745H0.5ZM10.455 3.99117C10.455 5.09086 9.56355 5.98234 8.46386 5.98234V7.98234C10.6681 7.98234 12.455 6.19543 12.455 3.99117H10.455ZM8.46386 5.98234C7.36417 5.98234 6.47269 5.09086 6.47269 3.99117H4.47269C4.47269 6.19543 6.2596 7.98234 8.46386 7.98234V5.98234ZM6.47269 3.99117C6.47269 2.89148 7.36417 2 8.46386 2V0C6.2596 0 4.47269 1.78691 4.47269 3.99117H6.47269ZM8.46386 2C9.56355 2 10.455 2.89148 10.455 3.99117H12.455C12.455 1.78691 10.6681 0 8.46386 0V2ZM12.5 15H14.5V13H12.5V15ZM14.5 15H16.5V13H14.5V15ZM15.5 16V14H13.5V16H15.5ZM15.5 14V12H13.5V14H15.5Z",
                                                fill: "#8E9CBB",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-table-actions__menu-item-label",
                                        on: { click: _vm.blockUserEmployee },
                                      },
                                      [
                                        _vm._v(
                                          " Заблокировать связанного пользователя "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "c-table-actions__menu-item-label-bold",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.infoAboutUserEmployee
                                                  .username
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.infoAboutUserEmployee &&
                            _vm.infoAboutUserEmployee.user_exist &&
                            _vm.infoAboutUserEmployee.user_status === 0
                              ? _c(
                                  "div",
                                  { staticClass: "c-table-actions__menu-item" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-table-actions__menu-item-icon",
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "20",
                                              height: "18",
                                              viewBox: "0 0 18 18",
                                              fill: "none",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M10.5 11.9863C11.0523 11.9863 11.5 11.5386 11.5 10.9863C11.5 10.434 11.0523 9.98628 10.5 9.98628V11.9863ZM5.23896 10.9863V9.98628V10.9863ZM1.5 14.9745H0.5H1.5ZM0.5 16.0625C0.5 16.6148 0.947715 17.0625 1.5 17.0625C2.05228 17.0625 2.5 16.6148 2.5 16.0625H0.5ZM12.5 13C11.9477 13 11.5 13.4477 11.5 14C11.5 14.5523 11.9477 15 12.5 15V13ZM16.5 15C17.0523 15 17.5 14.5523 17.5 14C17.5 13.4477 17.0523 13 16.5 13V15ZM13.5 16C13.5 16.5523 13.9477 17 14.5 17C15.0523 17 15.5 16.5523 15.5 16H13.5ZM15.5 12C15.5 11.4477 15.0523 11 14.5 11C13.9477 11 13.5 11.4477 13.5 12H15.5ZM10.5 9.98628H5.23896V11.9863H10.5V9.98628ZM5.23896 9.98628C3.96052 9.98628 2.74859 10.5286 1.86558 11.4705L3.32465 12.8383C3.84403 12.2843 4.53413 11.9863 5.23896 11.9863V9.98628ZM1.86558 11.4705C0.984619 12.4102 0.5 13.6716 0.5 14.9745H2.5C2.5 14.1619 2.80323 13.3945 3.32465 12.8383L1.86558 11.4705ZM0.5 14.9745V16.0625H2.5V14.9745H0.5ZM10.455 3.99117C10.455 5.09086 9.56355 5.98234 8.46386 5.98234V7.98234C10.6681 7.98234 12.455 6.19543 12.455 3.99117H10.455ZM8.46386 5.98234C7.36417 5.98234 6.47269 5.09086 6.47269 3.99117H4.47269C4.47269 6.19543 6.2596 7.98234 8.46386 7.98234V5.98234ZM6.47269 3.99117C6.47269 2.89148 7.36417 2 8.46386 2V0C6.2596 0 4.47269 1.78691 4.47269 3.99117H6.47269ZM8.46386 2C9.56355 2 10.455 2.89148 10.455 3.99117H12.455C12.455 1.78691 10.6681 0 8.46386 0V2ZM12.5 15H14.5V13H12.5V15ZM14.5 15H16.5V13H14.5V15ZM15.5 16V14H13.5V16H15.5ZM15.5 14V12H13.5V14H15.5Z",
                                                fill: "#8E9CBB",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-table-actions__menu-item-label",
                                        on: { click: _vm.unlockUserEmployee },
                                      },
                                      [
                                        _vm._v(
                                          " Разблокировать связанного пользователя "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "c-table-actions__menu-item-label-bold",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.infoAboutUserEmployee
                                                  .username
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "c-table-actions__menu-item" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-table-actions__menu-item-icon",
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "14",
                                          height: "15",
                                          viewBox: "0 0 14 15",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M1.5 3C0.947715 3 0.5 3.44772 0.5 4C0.5 4.55228 0.947715 5 1.5 5V3ZM12.5 5C13.0523 5 13.5 4.55228 13.5 4C13.5 3.44772 13.0523 3 12.5 3V5ZM3.42846 3.6C3.42846 4.15228 3.87618 4.6 4.42846 4.6C4.98075 4.6 5.42846 4.15228 5.42846 3.6H3.42846ZM5.71418 1V0V1ZM8.28561 1V0V1ZM8.57132 3.6C8.57132 4.15228 9.01903 4.6 9.57132 4.6C10.1236 4.6 10.5713 4.15228 10.5713 3.6H8.57132ZM6.5 7C6.5 6.44772 6.05228 6 5.5 6C4.94772 6 4.5 6.44772 4.5 7H6.5ZM4.5 11C4.5 11.5523 4.94772 12 5.5 12C6.05228 12 6.5 11.5523 6.5 11H4.5ZM9.5 7C9.5 6.44772 9.05228 6 8.5 6C7.94772 6 7.5 6.44772 7.5 7H9.5ZM7.5 11C7.5 11.5523 7.94772 12 8.5 12C9.05228 12 9.5 11.5523 9.5 11H7.5ZM1.5 5H12.5V3H1.5V5ZM5.42846 3.6V2.3H3.42846V3.6H5.42846ZM5.42846 2.3C5.42846 2.21689 5.46122 2.13938 5.51604 2.08395L4.09404 0.677572C3.66663 1.10973 3.42846 1.69355 3.42846 2.3H5.42846ZM5.51604 2.08395C5.5705 2.02889 5.64199 2 5.71418 2V0C5.10438 0 4.52182 0.245036 4.09404 0.677572L5.51604 2.08395ZM5.71418 2H8.28561V0H5.71418V2ZM8.28561 2C8.35779 2 8.42929 2.02889 8.48374 2.08395L9.90575 0.677572C9.47796 0.245036 8.8954 0 8.28561 0V2ZM8.48374 2.08395C8.53856 2.13938 8.57132 2.21689 8.57132 2.3H10.5713C10.5713 1.69355 10.3332 1.10973 9.90575 0.677572L8.48374 2.08395ZM8.57132 2.3V3.6H10.5713V2.3H8.57132ZM4.5 7V11H6.5V7H4.5ZM7.5 7V11H9.5V7H7.5ZM10.5 4V12H12.5V4H10.5ZM9.5 13H4.5V15H9.5V13ZM3.5 12V4H1.5V12H3.5ZM4.5 13C3.94772 13 3.5 12.5523 3.5 12H1.5C1.5 13.6569 2.84315 15 4.5 15V13ZM10.5 12C10.5 12.5523 10.0523 13 9.5 13V15C11.1569 15 12.5 13.6569 12.5 12H10.5Z",
                                            fill: "#FF238D",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-table-actions__menu-item-label",
                                    on: {
                                      click: function ($event) {
                                        _vm.isActiveDeleteConfirmationModal = true
                                      },
                                    },
                                  },
                                  [_vm._v(" Удалить сотрудника ")]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.getWorksheetStatus() === "success"
                    ? _c(
                        "b-popover",
                        {
                          attrs: {
                            triggers: "hover",
                            target: `c-table-actions__action-worksheet-success-${_vm.recordIndex}`,
                          },
                        },
                        [_vm._v(" Анкета заполнена ")]
                      )
                    : _vm._e(),
                  _vm.getWorksheetStatus() === "error"
                    ? _c(
                        "b-popover",
                        {
                          attrs: {
                            triggers: "hover",
                            target: `c-table-actions__action-worksheet-error-${_vm.recordIndex}`,
                          },
                        },
                        [_vm._v(" Анкета не заполнена ")]
                      )
                    : _vm._e(),
                  _vm.getWorksheetStatus() === "warning"
                    ? _c(
                        "b-popover",
                        {
                          attrs: {
                            triggers: "hover",
                            target: `c-table-actions__action-worksheet-warning-${_vm.recordIndex}`,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "c-table-actions__worksheet-tooltip",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-table-actions__worksheet-tooltip-title",
                                },
                                [_vm._v("Заполнено")]
                              ),
                              _c("table", [
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "c-table-actions__worksheet-tooltip-meta",
                                    },
                                    [_vm._v("Обязательных полей")]
                                  ),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.required !== undefined
                                          ? _vm.required.count
                                          : null
                                      )
                                    ),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.required !== undefined
                                          ? _vm.required.percentage
                                          : null
                                      ) + "%"
                                    ),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "c-table-actions__worksheet-tooltip-meta",
                                    },
                                    [_vm._v("Дополнительных полей")]
                                  ),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.additional !== undefined
                                          ? _vm.additional.count
                                          : null
                                      )
                                    ),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.additional !== undefined
                                          ? _vm.additional.percentage
                                          : null
                                      ) + "%"
                                    ),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "c-table-actions__worksheet-tooltip-meta",
                                    },
                                    [_vm._v("Всего")]
                                  ),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.total !== undefined
                                          ? _vm.total.count
                                          : null
                                      )
                                    ),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.total !== undefined
                                          ? _vm.total.percentage
                                          : null
                                      ) + "%"
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.type === "calculations"
            ? _c("div", { staticClass: "c-table-actions__wrapper" }, [
                _c(
                  "a",
                  {
                    staticClass: "c-table-actions__action",
                    attrs: {
                      href: `/?r=redesign#/calculation/production?calc_id=${_vm.record.id}`,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "c-table-actions__icon",
                        attrs: {
                          id: `c-table-actions__action-worksheet-warning-${_vm.recordIndex}`,
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "15",
                              height: "17",
                              viewBox: "0 0 15 17",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M9.33943 1.62805L8.63232 0.920947L8.63232 0.920948L9.33943 1.62805ZM10.8557 1V0V1ZM13 3.14431H14H13ZM12.3719 4.66057L11.6648 3.95346L11.6648 3.95346L12.3719 4.66057ZM5.16971 11.8628L5.43283 12.8276C5.60073 12.7818 5.75376 12.693 5.87682 12.5699L5.16971 11.8628ZM1 13L0.0352364 12.7369C-0.0591854 13.0831 0.0391427 13.4534 0.292893 13.7071C0.546642 13.9609 0.916904 14.0592 1.26312 13.9648L1 13ZM2.13719 8.8303L1.43009 8.12319C1.30703 8.24625 1.21822 8.39929 1.17243 8.56718L2.13719 8.8303ZM10.0465 2.33516C10.1528 2.2289 10.2789 2.14461 10.4178 2.08711L9.65241 0.239346C9.27093 0.397362 8.9243 0.62897 8.63232 0.920947L10.0465 2.33516ZM10.4178 2.08711C10.5566 2.0296 10.7054 2 10.8557 2V0C10.4428 0 10.0339 0.0813298 9.65241 0.239346L10.4178 2.08711ZM10.8557 2C11.006 2 11.1548 2.0296 11.2936 2.08711L12.059 0.239346C11.6775 0.0813296 11.2686 0 10.8557 0V2ZM11.2936 2.08711C11.4324 2.14461 11.5586 2.2289 11.6648 2.33516L13.0791 0.920947C12.7871 0.628971 12.4404 0.397363 12.059 0.239346L11.2936 2.08711ZM11.6648 2.33516C11.7711 2.44142 11.8554 2.56757 11.9129 2.7064L13.7607 1.94103C13.6026 1.55955 13.371 1.21292 13.0791 0.920947L11.6648 2.33516ZM11.9129 2.7064C11.9704 2.84523 12 2.99403 12 3.14431H14C14 2.7314 13.9187 2.32252 13.7607 1.94103L11.9129 2.7064ZM12 3.14431C12 3.29459 11.9704 3.44339 11.9129 3.58222L13.7607 4.34759C13.9187 3.9661 14 3.55722 14 3.14431H12ZM11.9129 3.58222C11.8554 3.72105 11.7711 3.8472 11.6648 3.95346L13.0791 5.36768C13.371 5.0757 13.6026 4.72907 13.7607 4.34759L11.9129 3.58222ZM11.6648 3.95346L4.46261 11.1557L5.87682 12.5699L13.0791 5.36767L11.6648 3.95346ZM4.9066 10.898L0.736884 12.0352L1.26312 13.9648L5.43283 12.8276L4.9066 10.898ZM1.96476 13.2631L3.10196 9.09342L1.17243 8.56718L0.0352364 12.7369L1.96476 13.2631ZM2.8443 9.53741L10.0465 2.33516L8.63232 0.920948L1.43009 8.12319L2.8443 9.53741ZM7 4L10 7L11.4142 5.58579L8.41421 2.58579L7 4Z",
                                fill: "#8E9CBB",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm.canAllDelete ||
                _vm.canDeleteFiilals.indexOf(_vm.record.filial_id) >= 0
                  ? _c(
                      "div",
                      {
                        staticClass: "c-table-actions__action",
                        on: {
                          click: function ($event) {
                            _vm.isActiveDeleteCalcConfirmationModal = true
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "c-table-actions__icon",
                            attrs: {
                              id: `c-table-actions__action-worksheet-warning-${_vm.recordIndex}`,
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "15",
                                  height: "17",
                                  viewBox: "0 0 15 17",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M1.5 3C0.947715 3 0.5 3.44772 0.5 4C0.5 4.55228 0.947715 5 1.5 5V3ZM12.5 5C13.0523 5 13.5 4.55228 13.5 4C13.5 3.44772 13.0523 3 12.5 3V5ZM3.42846 3.6C3.42846 4.15228 3.87618 4.6 4.42846 4.6C4.98075 4.6 5.42846 4.15228 5.42846 3.6H3.42846ZM5.71418 1V0V1ZM8.28561 1V0V1ZM8.57132 3.6C8.57132 4.15228 9.01903 4.6 9.57132 4.6C10.1236 4.6 10.5713 4.15228 10.5713 3.6H8.57132ZM6.5 7C6.5 6.44772 6.05228 6 5.5 6C4.94772 6 4.5 6.44772 4.5 7H6.5ZM4.5 11C4.5 11.5523 4.94772 12 5.5 12C6.05228 12 6.5 11.5523 6.5 11H4.5ZM9.5 7C9.5 6.44772 9.05228 6 8.5 6C7.94772 6 7.5 6.44772 7.5 7H9.5ZM7.5 11C7.5 11.5523 7.94772 12 8.5 12C9.05228 12 9.5 11.5523 9.5 11H7.5ZM1.5 5H12.5V3H1.5V5ZM5.42846 3.6V2.3H3.42846V3.6H5.42846ZM5.42846 2.3C5.42846 2.21689 5.46122 2.13938 5.51604 2.08395L4.09404 0.677572C3.66663 1.10973 3.42846 1.69355 3.42846 2.3H5.42846ZM5.51604 2.08395C5.5705 2.02889 5.64199 2 5.71418 2V0C5.10438 0 4.52182 0.245036 4.09404 0.677572L5.51604 2.08395ZM5.71418 2H8.28561V0H5.71418V2ZM8.28561 2C8.35779 2 8.42929 2.02889 8.48374 2.08395L9.90575 0.677572C9.47796 0.245036 8.8954 0 8.28561 0V2ZM8.48374 2.08395C8.53856 2.13938 8.57132 2.21689 8.57132 2.3H10.5713C10.5713 1.69355 10.3332 1.10973 9.90575 0.677572L8.48374 2.08395ZM8.57132 2.3V3.6H10.5713V2.3H8.57132ZM4.5 7V11H6.5V7H4.5ZM7.5 7V11H9.5V7H7.5ZM10.5 4V12H12.5V4H10.5ZM9.5 13H4.5V15H9.5V13ZM3.5 12V4H1.5V12H3.5ZM4.5 13C3.94772 13 3.5 12.5523 3.5 12H1.5C1.5 13.6569 2.84315 15 4.5 15V13ZM10.5 12C10.5 12.5523 10.0523 13 9.5 13V15C11.1569 15 12.5 13.6569 12.5 12H10.5Z",
                                    fill: "#FF238D",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }